export const scrollTo = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      block: window.innerWidth < 1024 ? 'start' : 'center',
      behavior: 'smooth',
    });
    window.location.hash = `#${id}`;
  }
};